import { render, staticRenderFns } from "./Unauthorize.vue?vue&type=template&id=169e4335&scoped=true"
import script from "./Unauthorize.vue?vue&type=script&lang=js"
export * from "./Unauthorize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169e4335",
  null
  
)

export default component.exports